import { useApiPost } from '@/api/main/query'
import { useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/shared/hooks'
import { TransferBalance } from '../model'
import { TraderBalances } from '@/entities/balances'
import { traderBalanceAPI } from '../api'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'

export const useTransferBalance = (onSuccessCallback?: () => void) => {
  const { addToast } = useToast()
  const queryClient = useQueryClient()
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  const { mutate: transferBalance, isPending: isPendingTransfer } = useApiPost<
    TraderBalances,
    TransferBalance
  >(traderBalanceAPI.transfer, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['balances', userRole] })
      addToast('Успешно!', 'Перевод выполнен', 'success')
      if (onSuccessCallback) onSuccessCallback()
    },
    onError: (error) => {
      addToast('Ошибка!', error.message, 'error')
    },
  })

  const handleTransferBalance = (data: TransferBalance) => {
    transferBalance(data)
  }

  return { handleTransferBalance, isPendingTransfer }
}
